module.exports = __webpack_public_path__ + "img/wav1.930dc507.gif";